import { Outlet } from "react-router";
import Header from "./Header";
import SideBar from "./SideBar";

export default function DashboardLayout() {
  return (
    <div className="flex">
      <div className="sticky print:hidden lg:flex hidden top-0 right-0 z-50! h-screen border-l border-grayscale-200">
        <SideBar />
      </div>
      <div className="flex flex-col flex-1">
        <Header />
        <main className="flex-1 print:py-0 py-6 print:px-0 lg:px-10 px-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
